import React from 'react'
import { useTranslation } from 'react-i18next'
import "./accessFrom.scss"

function AccessFrom() {
  const {t} =  useTranslation()
  return (
    <div className='container-access-from'>
        <div className='texts-access-from'>
            <h1>{t("reports.access_form.title")}</h1>
            <p>{t("reports.access_form.section_text_1")}</p>
            <p>{t("reports.access_form.section_text_2")}</p>
        </div>
    </div>
  )
}

export default AccessFrom